import noop from 'lodash/noop';
import { useLocation } from 'react-router';

import { testIsActiveLink } from '~/eds/src/modules/PageHeader/utils';
import { useNavlinks } from '~/utils/navLinks';

/** Whether the legacy top navbar is rendering a sub-nav row for the current route. */
export function useHasLegacySubNav() {
  const { pathname } = useLocation();
  const links = useNavlinks(noop);
  return Boolean(links.find(testIsActiveLink(pathname))?.children?.length);
}
